import { App, reactive, inject } from 'vue';
import { AppHistoryOptions } from 'Common/types/plugins/appHistoryOptions';
import { ApplicationHistoryList } from 'Common/types/plugins/applicationHistoryList';

const key = Symbol()

export function useAppHistory() {
    const history = inject<ApplicationHistoryList>(key);
    return history;
}

export default {
    install: (app: App, options: AppHistoryOptions) => {
        const state = reactive<ApplicationHistoryList>({ entries: [] })
        const { router, maxHistoryEntries } = options;

        router.beforeEach((to, from) => {
            if (state.entries.length === (maxHistoryEntries || 25)) {
                state.entries.shift()
            }
            state.entries.push({ to, from });
        })

        app.provide(key, state);
    }
}